import { useEffect, useRef, useState } from 'react'

import {
  Box,
  Container,
  Icon,
  Text,
  TransparentButton,
} from '@redriverpress/system'

import CollectionIndex from './CollectionIndex'

export default function CollectionIndexMenu() {
  const [menuOpen, setMenuOpen] = useState(false)

  const menuRef = useRef(null)

  useEffect(() => {
    // Ideally this would use a ref, which would be more programmatic to React.
    // But since react router places this aria attribute on the currently active
    // NavLink, I think this is a decent workaround.
    const activeLinkOffset = document.querySelector('[aria-current="page"]')
      .offsetTop

    // Scroll the dropdown element to the active link.
    // By listing `menuOpen` as an effect dependency, the scrollTop value
    // will update whenever the menu opens.
    menuRef.current.scrollTop = activeLinkOffset
  }, [menuOpen])

  return (
    <>
      <Box bg='white' boxShadow={2} position='relative' zIndex={1}>
        <TransparentButton
          onClick={() => setMenuOpen(x => !x)}
          width={1}
          px={0}
          aria-haspopup='true'
          aria-controls='collectionIndex'
          aria-expanded={menuOpen}
        >
          <Container display='flex' alignItems='center' py={3}>
            <Text as='span' fontWeight={600}>
              Content
            </Text>
            <Icon icon={menuOpen ? 'chevron-up' : 'chevron-down'} ml='auto' />
          </Container>
        </TransparentButton>
      </Box>
      <Box
        ref={menuRef}
        position='absolute'
        left={0}
        right={0}
        maxHeight='50vh'
        overflowY='scroll'
        bg='white'
        boxShadow={1}
        display={menuOpen ? 'block' : 'none'}
        zIndex={2}
      >
        <Container>
          <CollectionIndex />
        </Container>
      </Box>
    </>
  )
}
